import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';

const Upgrade = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '' });
  return (
    <>
      <link rel="stylesheet" href="styles/ie.css" />
      <div className="notice-container">
        <h1>{t('$common.internetExplorerTitle')}</h1>
        <p>{t('$common.internetExplorerDescription')}</p>
        <ul>
          <li>
            <a href="https://www.google.com/chrome/dr/download/">
              <img
                src="images/misc/browsers/chrome.svg"
                alt="Chrome logo"
                decoding="async"
                fetchPriority="low"
              />
              <span>Google Chrome</span>
            </a>
          </li>
          <li>
            <a href="https://www.mozilla.org/firefox">
              <img
                src="images/misc/browsers/firefox.svg"
                alt="Firefox logo"
                decoding="async"
                fetchPriority="low"
              />
              <span>Firefox</span>
            </a>
          </li>

          <li>
            <a href="https://www.apple.com/safari/">
              <img
                src="images/misc/browsers/safari.svg"
                alt="Safari logo"
                decoding="async"
                fetchPriority="low"
              />
              <span>Safari</span>
            </a>
          </li>
        </ul>
        <ul>
          <li>
            <a href="https://www.microsoft.com/en-us/edge">
              <img
                src="images/misc/browsers/edge.svg"
                alt="Edge logo"
                decoding="async"
                fetchPriority="low"
              />
              <span>Edge</span>
            </a>
          </li>
          <li>
            <a href="https://www.opera.com/">
              <img
                src="images/misc/browsers/opera.svg"
                alt="Opera logo"
                decoding="async"
                fetchPriority="low"
              />
              <span>Opera</span>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Upgrade;
